import { Grid } from '@mui/material';
import { Stack } from '@mui/system';
import { IPatientInfo } from 'apis/admin/type';
import Form from 'components/Form';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import RowContainer from '../components/RowContainer';
import RowContent from '../components/RowContent';
import SectionTitle from '../components/SectionTitle';

interface Props extends IFormRegister, IFormValues, IFormWatch {
  disabled?: boolean;
}

const checks_situation = [
  {
    label: 'HBs Ag',
    key: 'infection_state.checked1',
  },
  {
    label: 'HBs Ab',
    key: 'infection_state.checked2',
  },
  {
    label: '모름',
    key: 'infection_state.checked5',
  },
  {
    label: '기타',
    key: 'infection_state.checked6',
  },
];

const After = (props: Props) => {
  const { disabled, watch, setValue, getValues, register } = props;

  return (
    <>
      <SectionTitle title="4. 감염노출 후 조치" mb={3} mt={3} />

      <RowContainer xs={12}>
        <RowContent title="감염상태" titleRatio={1} childrenRatio={11}>
          <Stack direction="row">
            {checks_situation.map((v, i) => {
              return (
                <Grid item xs={i === 3 ? 0.6 : 1.8}>
                  <Stack direction="row">
                    <Form.MuiCheckbox
                      label={v.label}
                      disabled={disabled}
                      defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                      onChange={(_, checked) => {
                        setValue(v.key, checked);
                      }}
                    />
                  </Stack>
                </Grid>
              );
            })}
            <Form.MuiTextField
              required={false}
              sx={{ width: '120px' }}
              disabled={disabled}
              placeholder="직접 입력"
              {...register(`infection_after_input`)}
            />
          </Stack>
        </RowContent>
      </RowContainer>

      <RowContainer xs={12} sx={{ marginTop: '5px' }}>
        <RowContainer>
          <RowContent title="투여 약제">
            <Stack direction="row">
              <Form.MuiTextField
                required={false}
                disabled={disabled}
                placeholder="직접 입력"
                {...register(`infection_after_medi`)}
              />
            </Stack>
          </RowContent>
        </RowContainer>
        <RowContainer>
          <RowContent title="감염원(환자) 추가검사">
            <Stack direction="row">
              <Form.MuiTextField
                required={false}
                disabled={disabled}
                placeholder="직접 입력"
                sx={{ marginLeft: '20px' }}
                {...register(`infection_after_test`)}
              />
            </Stack>
          </RowContent>
        </RowContainer>
      </RowContainer>
    </>
  );
};

export default After;
